"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistedUILibVersion = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const common_1 = require("../../../common");
const AssistedUILibVersion = ({ children }) => (react_1.default.createElement(react_1.default.Fragment, null,
    children,
    react_1.default.createElement("div", { "data-testid": "assisted-ui-lib-version", hidden: true }, (0, common_1.getAssistedUiLibVersion)())));
exports.AssistedUILibVersion = AssistedUILibVersion;
//# sourceMappingURL=AssistedUILibVersion.js.map